import { render, staticRenderFns } from "./LossDeletion.vue?vue&type=template&id=73e144df&scoped=true"
import script from "./LossDeletion.vue?vue&type=script&lang=js"
export * from "./LossDeletion.vue?vue&type=script&lang=js"
import style0 from "./LossDeletion.vue?vue&type=style&index=0&id=73e144df&prod&scoped=true&lang=css"
import style1 from "./LossDeletion.vue?vue&type=style&index=1&id=73e144df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e144df",
  null
  
)

export default component.exports